export const environment = {
  production: true,
  apiUrl: 'https://klantportaal-api.brandscompart.nl',
  google: {
    apiKey: 'AIzaSyAJ0ITBxflxac1Ma1FjWpE4h7t8ARJqsok'
  }
};



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/environments/environment.ts